/**
 * 区分 roleCategoryType（roles.role_category_type）
 * 出典：02 D-078
 */
export const ROLE_CATEGORY_TYPE_VALUES = ['system', 'custom'] as const;

export type RoleCategoryType = (typeof ROLE_CATEGORY_TYPE_VALUES)[number];

export const ROLE_CATEGORY_TYPE_LABELS: Readonly<Record<RoleCategoryType, string>> = {
  system: 'システム',
  custom: 'カスタム',
};
